module.exports = __webpack_public_path__ + "static/media/service-icon-3.70bed9b6.webp";